import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import WelcomeBanner from "../common/WelcomeBanner";
import React, { useContext, useEffect, useState } from "react";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { isValidPassword } from "../../utils/validators";
import { logoutUser, resetPassword } from "../../services/authService";
import { useSearchParams } from "react-router-dom";
import "./styles.scss";
import { deleteToken } from "../../core/auth";
import { AuthContext } from "../../core/authContext";
import PasswordField from "../common/PasswordField/PasswordField";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [isPasswordMatching, setIsPasswordMatching] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [token, setToken] = useState("");
  const [searchParams] = useSearchParams();
  const [error, setError] = useState("");
  const [isPassResetSuccessfull, setIsPassResetSuccessfull] = useState(false);
  const { isLoggedIn }: any = useContext(AuthContext);

  useEffect(() => {
    setToken(searchParams.get("accessToken") || "");
  }, [searchParams]);
  const navigate = useNavigate();

  const passwordChangeHandler = (event: any) => {
    event.preventDefault();
    setPassword(event.target.value);
  };

  const confirmPasswordChangeHandler = (event: any) => {
    event.preventDefault();
    setConfirmPassword(event.target.value);
  };

  const handleResetPassword = () => {
    setIsLoading(true);
    if (!passwordError && !confirmPasswordError && isPasswordMatching) {
      resetPassword(password, token)
        .then(() => {
          setIsLoading(false);
          setIsPassResetSuccessfull(true);
        })
        .catch(() => {
          setError("Something went wrong!! Please try again");
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    if (isLoggedIn && isPassResetSuccessfull) {
      logoutUser().then(() => {
        deleteToken();
      });
    }
  }, [isPassResetSuccessfull]);

  useEffect(() => {
    const isPasswordValid = isValidPassword(password);
    setPasswordError(
      !isPasswordValid && password ? "Please enter valid password" : ""
    );
    const isConfirmPasswordValid = isValidPassword(confirmPassword);
    setConfirmPasswordError(
      !isConfirmPasswordValid && confirmPassword
        ? "Please enter valid password"
        : ""
    );
    setIsPasswordMatching(password === confirmPassword);
  }, [password, confirmPassword]);

  return (
    <Box component="div" className="reset-password-container">
      <Box sx={{ my: 1 }}>
        <WelcomeBanner />
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <Card className="card-container">
          {isPassResetSuccessfull ? (
            <CardContent className="card-content">
              <Typography className="password-reset-message">
                Password was reset successfully!!
              </Typography>
              <Button
                variant="contained"
                fullWidth
                className="reset-password-button"
                onClick={() => navigate("/login")}
              >
                BACK TO LOGIN
              </Button>
            </CardContent>
          ) : (
            <CardContent className="card-content">
              <Typography className="reset-password-text">
                Create New Password
              </Typography>
              <Typography className="password-requirements">
                Your password must be between 8 and 16 characters in length.
              </Typography>
              <Typography className="password-requirements-subtext">
                Password must contain A-Z, a-z, 0-9, !@#$%&
              </Typography>
              <form autoComplete="off" className="form">
                <PasswordField
                  label="New Password"
                  changeHandler={passwordChangeHandler}
                  error={passwordError}
                  isValid={!!passwordError}
                  testId="newPassword"
                  value={password}
                />
                <PasswordField
                  label="Confirm New Password"
                  changeHandler={confirmPasswordChangeHandler}
                  error={confirmPasswordError}
                  isValid={!!confirmPasswordError}
                  testId="confirmPassword"
                  value={confirmPassword}
                />
                <Typography
                  variant="sFormHelper"
                  className="password-not-matching-error"
                >
                  {!passwordError &&
                    !!confirmPassword &&
                    !confirmPasswordError &&
                    !isPasswordMatching &&
                    "Password Not matching"}
                </Typography>
                <Typography variant="sFormHelper" className="api-error">
                  {error ?? ""}
                </Typography>
                <LoadingButton
                  fullWidth
                  variant="contained"
                  data-testid="resetLinkBtn"
                  size="small"
                  sx={{
                    marginBottom: "16px",
                    height: "44px",
                  }}
                  disabled={!password || !confirmPassword}
                  onClick={handleResetPassword}
                  loading={isLoading}
                >
                  CREATE PASSWORD
                </LoadingButton>
              </form>
            </CardContent>
          )}
        </Card>
      </Box>
    </Box>
  );
};

export default ResetPassword;
